module.exports = __webpack_public_path__ + "static/media/CTDC_Tutorial_Video_Placeholder.ac973a81.png";